export default __webpack_public_path__ + "static/media/slider-madrid-2.9b9ddc01.jpg";